import { paymentLinksTranslations } from "./payment-links-pt-br";

export const paymentLinks_FR_FR: paymentLinksTranslations = {
	title: "Liens de paiement",
	description: "Créez et suivez les encaissements ponctuels de l'établissement.",
	searchPlaceholder: "Rechercher par ID du lien",
	createButton: "Nouvel encaissement",
	empty: "Aucun lien de paiement créé",
	emptyDescription: "Créez un nouvel encaissement pour générer un lien de paiement.",
	copyLink: "Copier le lien",
	open: "Ouvrir",
	linkCopied: "Lien copié dans le presse-papiers",
	perPage: "page",
	columns: {
		id: "ID du lien",
		amount: "Montant",
		installments: "Mensualités",
		status: "Statut",
		origin: "Règlement",
		createdAt: "Créé le",
		actions: "Actions",
	},
	status: {
		PENDING: "En attente",
		PAID: "Payé",
		EXPIRED: "Expiré",
		CANCELED: "Annulé",
	},
	origin: {
		zig: "Compte Zig",
		place: "Compte de l'établissement",
	},
	modal: {
		title: "Nouvel encaissement",
		amount: "Montant de l'encaissement",
		amountPlaceholder: "€ 0,00",
		installments: "Mensualités",
		paymentOrigin: "Compte de règlement",
		description: "Description",
		descriptionPlaceholder: "Décrivez l'encaissement que le payeur verra",
		cancel: "Annuler",
		submit: "Générer le lien de paiement",
		successMessage: "Lien de paiement créé avec succès",
		requiredField: "Champ obligatoire",
		generatedTitle: "Lien de paiement généré",
		generatedDescription: "Copiez et envoyez le lien au payeur.",
		copyLink: "Copier le lien",
		linkCopied: "Lien copié dans le presse-papiers",
		done: "Terminé",
	},
};
